const ComplementoIneRules  = (data = {}) => {
  let TipoProcesoRule = 'string';

  if (data.TipoProceso === 'Ordinario') {
    TipoProcesoRule = 'required';
  }

  return {
    TipoProceso: [
      'required',
      'string',
      'in:Ordinario,Precampaña,Campaña',
    ],
    TipoComite: [
      TipoProcesoRule,
      'string',
      'in:Ejecutivo Nacional,Ejecutivo Estatal,Directivo Estatal',
    ],
    IdContabilidad: [
      'int',
      'digits:6',
    ],
    telephone: [
      'telephone',
    ]
  }
};

export default ComplementoIneRules;
